import { CLIENT } from '../constant/actionTypes';

const getClientSoftwares = (state, action) => {
  switch (action.type) {
    case CLIENT.SOFTWARES.INITIATE:
      return { isFetching: true };
    case CLIENT.SOFTWARES.SUCCESS:
      return { isFetching: false, data: action.payload };
    case CLIENT.SOFTWARES.ERROR:
      return { isFetching: false, data: action.payload };
    default:
      return (typeof state === 'undefined') ? [] : state;
  }
};

export default getClientSoftwares;
